import { Navigate } from "react-router-dom";
import EducationHolder from "../components/EducationHolder";
import React, { useContext } from "react";
import AuthContext from "../context/auth_context";

const EducationRoute = ({
  redirectPath = "/",
  component: Component,
  ...otherProps
}) => {
  const auth = useContext(AuthContext);
  if (!auth?.validUser) {
    return <Navigate to={redirectPath} replace />;
  }
  return (
    <EducationHolder>
      <Component {...otherProps} />
    </EducationHolder>
  );
};

export default EducationRoute;
